import { render, staticRenderFns } from "./Leave.vue?vue&type=template&id=6fd84404&scoped=true"
import script from "./Leave.vue?vue&type=script&lang=js"
export * from "./Leave.vue?vue&type=script&lang=js"
import style0 from "./Leave.vue?vue&type=style&index=0&id=6fd84404&prod&scoped=true&lang=css"
import style1 from "./Leave.vue?vue&type=style&index=1&id=6fd84404&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd84404",
  null
  
)

export default component.exports